import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { RequestHeadersProvider } from './request-headers.provider';
import { AppComponent } from './app.component';
import {
    ActionFactory,
    ActionService,
    ConditionFactory,
    InvitationService,
    LoggingService,
    NotificationService,
    OptionsService,
    SettingsService,
    SkillService,
    VisitService
} from './services';
import { AppMaterialModule } from './app-material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    AppMaterialModule,
    FontAwesomeModule
  ],
  providers: [
    RequestHeadersProvider,
    ActionFactory,
    ActionService,
    SkillService,
    InvitationService,
    NotificationService,
    OptionsService,
    SettingsService,
    VisitService,
    ConditionFactory,
    LoggingService
  ],
  bootstrap: [
    AppComponent
  ]
})

export class AppModule { }
